<template>
  <van-popup
      v-model="showPopup"
      position="right"
      :overlay="false"
      :close-on-click-overlay="false"
      :style="{ height: '100%' ,width:'90%'}"
  >
    <div class="popupView">
      <van-nav-bar
          title="群标签"
          left-arrow
          @click-left="onClickLeft"
      />
      <div class="popupTopView">
        <!-- <van-list
            v-model="loading"
            :finished="finished"
            :error="error"
            finished-text="没有更多了"
            error-text="数据加载失败，请重试"
            @load="onLoad"
        > -->
          <div class="filterView" v-for="(item,index) in filterItems" :key="index">
            <div class="rowFlex alignitems jus-btw">
              <div class="filterTitle">{{ item.name }}</div>
            </div>
            <div class="filterListView" v-if="item.bsLabel && item.bsLabel.length > 0">
              <div
                  :class="['filterItem ',selectFilterItemIds[item.id] && selectFilterItemIds[item.id].indexOf(fItem.id) > -1 ? 'activeItem' : 'normalItem']"
                  v-for="(fItem,fIndex) in item.bsLabel"
                  :key="fIndex"
                  @click="handleSelect(item,fItem)"
              >
                {{ fItem.name }}
              </div>
            </div>
          </div>
        <!-- </van-list> -->
      </div>
      <div class="popupBottomView">
<!--        <div class="tipView">-->
<!--          <div class="rowFlex alignitems m-b-12" @click.stop="handleSelectCondition(1)">-->
<!--            <img :src="condition == 1 ? selectedPic : unSelectedPic" class="imgView48 m-r-12"/>-->
<!--            <div class="tipTitle">以上标签满足其中之一</div>-->
<!--          </div>-->
<!--          <div class="rowFlex alignitems m-b-12" @click.stop="handleSelectCondition(2)">-->
<!--            <img :src="condition == 2 ? selectedPic : unSelectedPic" class="imgView48 m-r-12"/>-->
<!--            <div class="tipTitle">以上标签同时满足</div>-->
<!--          </div>-->
<!--        </div>-->
        <div class="actionView">
          <div :class="['rightBtn ',disabled ? 'normalBtn' : 'activeBtn']" @click.stop="handleConfirm">确定</div>
        </div>
      </div>
    </div>
  </van-popup>
</template>
<script>
import http from "@/utils/axios";

export default {
  props: {
    corpId: {
      type: String,
      default: () => {
        return ''
      }
    },
    show: {
      type: Boolean,
      default: () => {
        return false
      }
    },
    defaultLabelIds: {
      type: Object,
      default: () => {
        return {}
      }
    },
    defaultLabels: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      showPopup: false,
      selectedPic: require('@/assets/image/statisticManage/selected@3x.png'),
      unSelectedPic: require('@/assets/image/statisticManage/unSelect@3x.png'),
      disabled: true,// 确定按钮是否禁用
      condition: 1,
      loading: false,
      finished: false,
      error: false,
      page: 1,
      pageSize: 10,
      filterItems: [],
      total: 0,// 预计满足条件的群的个数
      selectFilterItems: {},// 选择的筛选项的集合
      selectFilterItemIds: {}// 选择的筛选项Id的集合
    }
  },
  watch: {
    show: {
      handler(val) {
        this.showPopup = val
      },
      immediate: true
    },
    defaultLabelIds: {
      handler(val) {
        if(val && Object.keys(val).length > 0){
          this.selectFilterItemIds = Object.assign({},this.selectFilterItemIds,val)
        }
      },
      immediate: true
    },
    defaultLabels: {
      handler(val) {
        if(val && Object.keys(val).length > 0){
          this.selectFilterItems = Object.assign({},this.selectFilterItems,val)
        }
      },
      immediate: true
    },
  },
  created() {
    this.getGroupList()
  },
  methods: {
    // 列表加载数据
    onLoad() {
      if (this.filterItems.length > 0 && this.filterItems.length >= this.total) {
        this.finished = true
        return
      }
      this.getGroupList()
    },
    /**
     * 获取群标签列表
     */
    getGroupList() {
      http({
        url: `order/dmp/dispatch/memberpush/BsGroupChatLabelRef/selectLabels?corpId=${this.corpId}&type=5`,
        method: "get",
        parmes: {}
      }).then(rps => {
        if (rps.code == 200) {
          let data = rps.data;
          this.filterItems = data;
          this.filterItems.forEach((cItem) => {
            if (cItem.bsLabel && cItem.bsLabel.length > 0) {
              if(!this.selectFilterItems[cItem.id]){
                this.$set(this.selectFilterItemIds, cItem.id, [])
                this.$set(this.selectFilterItems, cItem.id, [])
              }
            }
          })
          // this.page++
          // this.total = data.total ? data.total : this.filterItems.length
          // this.loading = false;
          // if (this.filterItems.length >= this.total) {
          //   this.finished = true;
          // }
        } else {
          this.$toast('请求异常，请稍后重试')
        }
        this.$loading.hide();
      }).catch(() => {
        this.$loading.hide();
        this.$toast('请求失败，请稍后重试')
      });
    },
    /**
     * @description 选中筛选项
     * @param {*} item 筛选项所属大类
     * @param {*} fItem 筛选项
     * @param {*} index 筛选项所属大类index
     * @param {*} fIndex 筛选项index
     */
    handleSelect(item, fItem) {
      if (this.selectFilterItemIds[item.id]) {// 如果已选中的数据包含当前大类
        let filterIndex = this.selectFilterItemIds[item.id].indexOf(fItem.id)
        if (filterIndex > -1) {// 如果当前筛选项已被选中，则取消选中
          this.selectFilterItemIds[item.id].splice(filterIndex, 1)
          this.selectFilterItems[item.id].splice(filterIndex, 1)
        } else {// 选中当前筛选项
          this.selectFilterItemIds[item.id].push(fItem.id)
          fItem.title = fItem.name
          this.selectFilterItems[item.id].push(fItem)
        }
      } else {
        fItem.title = fItem.name
        this.$set(this.selectFilterItemIds, item.id, [fItem.id])
        this.$set(this.selectFilterItems, item.id, [fItem])
      }
      if (Object.keys(this.selectFilterItemIds).length > 0) {
        let list = []
        for (let key in this.selectFilterItemIds) {
          list = list.concat(this.selectFilterItemIds[key])
        }
        this.disabled = list.length == 0
      } else {
        this.disabled = true
      }
    },
    // 确定
    handleConfirm() {
      if (!this.disabled) {
        this.$emit('confirm', this.selectFilterItemIds, this.selectFilterItems)
        this.selectFilterItemIds = {}
        this.selectFilterItems = {}
      }
    },
    // 返回按钮
    onClickLeft() {
      this.$emit('close')
    },
    // 选择筛选条件
    handleSelectCondition(type) {
      this.condition = type
    }
  }
}
</script>
<style lang="less" scoped>
@import url("../style/index.css");

.popupView {
  position: relative;
  height: 100%;
}

.popupTopView {
  padding: 24px 24px;
  height: calc(100% - 350px);
  overflow: scroll;

  .clearBtn {
    font-size: 24px;
    font-weight: 400;
    color: #E15554;
    line-height: 32px;
    margin-right: 24px;
  }

  .collapseBtn {
    font-size: 24px;
    font-weight: 400;
    color: #B4B4B4;
    line-height: 32px;
  }

  .filterView {
    width: 100%;
    display: flex;
    flex-direction: column;
    margin-bottom: 24px;

    .filterTitle {
      font-size: 28px;
      font-weight: 500;
      color: #3B3A38;
      line-height: 40px;
    }

    .filterListView {
      display: flex;
      align-items: flex-start;
      flex-wrap: wrap;
      width: 100%;

      .filterItem {
        flex-shrink: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        height: 60px;
        border-radius: 30px;
        padding: 0 24px;
        font-size: 26px;
        font-weight: 400;
        line-height: 36px;
        margin: 16px 16px 0 0;
      }

      .normalItem {
        background: #F2F2F2;
        color: #62615F;
        border: 2px solid #F2F2F2;
      }

      .activeItem {
        background: rgba(68, 102, 245, 0.1);
        border: 2px solid #4466F5;
        color: #4466F5;
      }
    }
  }

  /deep/ .van-cell {
    padding: 0 0 !important;

    &::after {
      border-bottom: none !important;
    }
  }

  /deep/ .van-collapse-item__content {
    padding: 0 0 !important;
  }

  /deep/ .van-collapse-item--border {
    &::after {
      border-top: none !important;
    }
  }
}

.popupBottomView {
  position: fixed;
  bottom: 0;
  width: 100%;
  display: flex;
  flex-direction: column;
  background: #FFFFFF;

  .tipView {
    display: flex;
    flex-direction: column;
    padding: 12px 24px;
    background: #FFFAE6;

    .tipTitle {
      font-size: 24px;
      font-weight: 500;
      color: #3B3A38;
      line-height: 24px;
    }
  }

  .actionView {
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    padding: 10px 32px;

    .rightBtn {
      width: 100%;
      height: 80px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 40px;
      font-size: 28px;
      font-weight: 500;
      line-height: 40px;
      color: #FFFFFF;
    }

    .normalBtn {
      background: #D1D1D1;
    }

    .activeBtn {
      background: #4466F5;
    }
  }
}
</style>